import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconAdobeInDesign20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconAdobeInDesign20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.5 3.5h11a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1M2 4.5A2.5 2.5 0 0 1 4.5 2h11A2.5 2.5 0 0 1 18 4.5v11a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 15.5zm4.04 2v7h1.32v-7zm3.332 6.85q.52.29 1.11.29.68 0 1.03-.23.36-.23.53-.51h.18v.6h1.24v-7h-1.26v2.61h-.18a1.2 1.2 0 0 0-.29-.34 1.5 1.5 0 0 0-.5-.26 2.2 2.2 0 0 0-.75-.11q-.6 0-1.11.3a2.13 2.13 0 0 0-.82.86q-.31.57-.31 1.38v.16q0 .81.31 1.38t.82.87m2.46-1.18q-.39.37-.97.37t-.97-.37q-.39-.38-.39-1.1v-.1q0-.72.39-1.09.39-.38.97-.38.59 0 .97.38.39.37.39 1.09v.1q0 .72-.39 1.1"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconAdobeInDesign20);
